<script setup>
import { useForm } from "@inertiajs/vue3";

import VInputReadonlyWithLabel from "@/Shared/Form/VInputReadonlyWithLabel.vue";

import VModal from "@/Shared/VModal.vue";
import RoleRow from "./RoleRow.vue";
import { ref } from "vue";

const props = defineProps({
    role: Object,
    menulist: Array,
});

const emits = defineEmits(["onSave", "onCancel"]);

const refModal = ref(null);

const title = "Detail User Access Role";

const activePermission = props.role?.permissions.map((item) => item.id) ?? [];

const form = useForm({
    selPermission: activePermission,
});

const cancel = () => {
    emits("onCancel");
};
</script>

<template>
    <VModal ref="refModal" :title="title" size="modal-lg" @onClose="cancel">
        <template v-slot:body>
            <div class="m-3">
                <form @submit.prevent="submit">
                    <div class="row">
                        <div class="col-lg-6">
                            <VInputReadonlyWithLabel
                                label="Name"
                                type="text"
                                :value="role.name"
                            />
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-hover">
                            <caption class="d-none">
                                Table Menu List
                            </caption>
                            <thead>
                                <tr>
                                    <th>No.</th>
                                    <th>Menu</th>
                                    <th>Permission</th>
                                </tr>
                            </thead>
                            <tbody>
                                <RoleRow
                                    v-for="(menu, index) in menulist"
                                    :key="menu.id"
                                    :menu="menu"
                                    v-model:value="form.selPermission"
                                    parentIteration=""
                                    :index="index"
                                    :isHeader="true"
                                    :isDisabled="true"
                                />
                            </tbody>
                        </table>
                    </div>
                </form>
            </div>
        </template>

        <template v-slot:footer>
            <div class="text-end"></div>
        </template>
    </VModal>
</template>
